import { FileSearch } from "lucide-react";

export default function EmptyState({ icon: Icon = FileSearch, title, children, actions, className = "" }) {
  return (
    <div className={`rounded-2xl border border-dashed border-border bg-card/60 px-6 py-12 text-center ${className}`}>
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-accent text-primary">
        <Icon className="h-7 w-7" aria-hidden="true" />
      </div>
      <h2 className="font-display text-lg font-semibold text-foreground">{title}</h2>
      {children && <p className="mx-auto mt-1.5 max-w-md text-sm text-muted-foreground">{children}</p>}
      {actions && <div className="mt-5 flex flex-wrap items-center justify-center gap-2">{actions}</div>}
    </div>
  );
}
